export default "__VITE_ASSET__DUcT_T2A__"